"use strict";

(function () {
    var components = document.querySelectorAll("[data-lazy-video-content]");
    var mobileQuery = window.matchMedia("(max-width: 767.98px)");

    function loadVideo(video) {
        if (video.dataset.loaded === "true") {
            return;
        }

        var poster = video.closest("[data-lazy-video-content]").querySelector("picture img");
        if (poster) {
            video.poster = poster.currentSrc || poster.src;
        }

        video.querySelectorAll("[data-src]").forEach(function (source) {
            source.src = (mobileQuery.matches && source.dataset.srcMobile) || source.dataset.src;
            if (source.tagName === "SOURCE") {
                video.src = source.src;
            }
            source.removeAttribute("data-src");
            source.removeAttribute("data-src-mobile");
        });
        video.muted = video.dataset.muted === "true";
        video.dataset.loaded = "true";
        video.load();
    }

    function showVideo(video) {
        video.closest("[data-lazy-video-content]").classList.add("is-video-ready");
    }

    function playVideo(video) {
        if (video.dataset.autoplay !== "true") {
            return;
        }

        var playPromise = video.play();
        if (playPromise) {
            playPromise.catch(function () {
                // Autoplay was blocked (e.g. unmuted), so restore controls for manual playback.
                video.controls = true;
            });
        }
    }

    function initialiseVideo(component, observer) {
        var video = component.querySelector("video");
        if (!video) {
            observer.unobserve(component);
            return;
        }

        if (video.dataset.initialised === "true") {
            return;
        }

        video.dataset.initialised = "true";
        video.addEventListener("playing", function () {
            showVideo(video);
        });
        video.addEventListener("loadeddata", function () {
            showVideo(video);
            if (video.dataset.inView === "true") {
                playVideo(video);
            }
        }, { once: true });
        loadVideo(video);
    }

    if (!("IntersectionObserver" in window)) {
        components.forEach(function (component) {
            var video = component.querySelector("video");
            if (video) {
                video.addEventListener("playing", function () {
                    showVideo(video);
                });
                video.addEventListener("loadeddata", function () {
                    showVideo(video);
                }, { once: true });
                loadVideo(video);
            }
        });
        return;
    }

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var video = entry.target.querySelector("video");

            if (entry.isIntersecting) {
                if (video) {
                    video.dataset.inView = "true";
                }
                initialiseVideo(entry.target, observer);
                if (video && video.dataset.loaded === "true") {
                    playVideo(video);
                }
            } else if (video) {
                video.dataset.inView = "false";
                if (!video.paused) {
                    video.pause();
                }
            }
        });
    }, { threshold: 0.15 });

    components.forEach(function (component) {
        observer.observe(component);
    });
})();
